import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const CardFeature = ({ image, title, description }) => {
  return (
    <div className="bg-white shadow-xl rounded-xl px-4 md:px-6 py-6 md:py-12 text-center flex flex-col items-center justify-between space-y-3 md:space-y-4">
      {/* Image replaces icon */}
      <img src={image} alt={title} className="w-12 h-12 md:w-16 md:h-16 object-contain" />

      <h3 className="text-base md:text-xl font-bold text-slate-800">{title}</h3>
      <p className="text-xs md:text-sm text-gray-600">{description}</p>

      {/* Yellow Gradient Button */}
      <Link to="/services"
        state={{ selectedCategory: title }}
        className="mt-4 text-white font-semibold text-sm py-1 px-2 md:text-base md:py-2 md:px-4 rounded shadow"
        style={{
          background: 'linear-gradient(135deg, #F2C231, #C69A32)',
        }}
      >
        SCOPRI DI PIÙ
      </Link>
    </div>
  );
};

export default CardFeature;
